import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
//import Login from '../views/pages/Login.vue';
import maincontainer from "../components/maincontainer.vue";
import { nextTick } from 'vue/types/umd';
import User from "../lib/user";

Vue.use(VueRouter)
const usr = new User();


const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: maincontainer,
    meta: {
      permission: 'USER'
    },
    children: [
      {
        path: '/plan',
        name: 'Plan',
        meta: {
          permission: 'SYSADM,GEOPLAN'
        },
        component: () => import(/* webpackChunkName: "adm" */ '../views/geo/plan.vue')
      },
    
      {
        path: '/lab',
        name: 'Lab',
        meta: {
          permission: 'SYSADM'
        },
        component: () => import(/* webpackChunkName: "adm" */ '../views/pages/labpage.vue')
      },
      {
        path: '/admin',
        name: 'Admin',
        meta: {
          permission: 'SYSADM'
        },
        component: () => import(/* webpackChunkName: "adm" */ '../views/admin/useractivity.vue')
      },
      {
        path: '/bookingltdlist',
        name: 'BookingLtd',
        meta: {
          permission: 'SYSADM,MANUALBOOKING'
        },
        component: () => import(/* webpackChunkName: "adm" */ '../views/booking/bookingltdlist.vue')
      },
      {
        path: '/sequence',
        name: 'Sequence',
        meta: {
          permission: 'ADM'
        },
        component: () => import(/* webpackChunkName: "adm" */ '../views/admin/sequence.vue')
      },
      {
        path: '/transferinvoices',
        name: 'Överför fakturor',
        meta: {
          permission: 'TR_INVOICE'
        },
        component: () => import(/* webpackChunkName: "transfer" */ '../views/transfer/invoicetransfer.vue')
      },
      {
        path: '/parties',
        name: 'Aktörer',
        meta: {
          permission: 'PARTIES,SYSADM'
        },
        component: () => import(/* webpackChunkName: "parties" */ '../views/party/partylist.vue')
      },
      {
        path: '/transferparties',
        name: 'Överför kunder',
        meta: {
          permission: 'TR_PARTY'
        },
        component: () => import(/* webpackChunkName: "transfer" */ '../views/transfer/partytransfer.vue')
      },

      {
        path: '/edi',
        name: 'EDI',
        meta: {
          permission: 'EDI'
        },
        component: () => import(/* webpackChunkName: "edi" */ '../views/edi/edilist.vue'),
      },
      {
        path: '/apimessage',
        name: 'API-meddelanden',
        meta: {
          permission: 'EDI'
        },
        component: () => import(/* webpackChunkName: "edi" */ '../views/edi/apimessagelist.vue'),
      },
      {
        path: '/logicsetedit',
        name: 'logicsetedit',
        meta: {
          permission: 'SETTINGS'
        },
        component: () => import(/* webpackChunkName: "settings" */ '../views/logic/logicsetedit.vue')
      },
      {
        path: '/logic',
        name: 'Logik',
        meta: {
          permission: 'SETTINGS'
        },
        component: () => import(/* webpackChunkName: "settings" */ '../views/logic/logictypelist.vue'),
        children: [
          {
            path: 'logicsetedit',
            name: 'Redigera logikuppsättning',
            meta: {
              permission: 'SETTINGS'
            },
            component: () => import(/* webpackChunkName: "settings" */ '../views/logic/logicsetedit.vue')
          }
        ]
      },
      {
        path: '/fuelcharge',
        name: 'DMT',
        meta: {
          permission: 'SETTINGS'
        },
        component: () => import(/* webpackChunkName: "settings" */ '../views/debit/fuelchargelist.vue')
      },
      {
        path: '/statperdayoverride',
        name: 'Överlagrad statistik',
        meta: {
          permission: 'SETTINGS'
        },
        component: () => import(/* webpackChunkName: "settings" */ '../views/logic/statperdayoverride.vue')
      },
      {
        path: '/consolidationroute',
        name: 'Flöden',
        meta: {
          permission: 'SETTINGS',
        },
        component: () => import(/* webpackChunkName: "settings" */ '../views/consolidationroute/consolidationroutelist.vue')
      },
      {
        path: '/tenant',
        name: 'Grundinställningar',
        meta: {
          permission: 'SYSADM'
        },
        component: () => import(/* webpackChunkName: "tenant" */ '../views/tenant/tenantinfo.vue'),
      },
      {
        path: '/home',
        name: 'Hem',
        meta: {
          permission: 'USER'
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
      },
      {
        path: '/todo',
        name: 'Att göra',
        meta: {
          permission: 'TODO'
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/todo/todolist.vue')
      },
      {
        path: '/bookings',
        name: 'Bookings',
        meta: {
          permission: 'ADM'
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/booking/bookinglist.vue')
      },
      {
        path: '/collibelonging',
        name: 'Lastbärartillhörighet',
        meta: {
          permission: 'SYSADM'
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/booking/collibelonging.vue')
      },
      {
        path: '/registerdebitevents',
        name: 'Debiteringshändelser',
        meta: {
          permission: 'DEBITADM,DEBITTSP'
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/event/registerdebitevents.vue')
      },
      {
        path: '/registerdata',
        name: 'Sodexodata',
        meta: {
          permission: 'ADM,GEOPLAN'
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/sodexo/registerdata.vue')
      },
      
       {
        path: '/registeraddresses',
        name: 'Sodexoadresser',
        meta: {
          permission: 'ADM,GEOPLAN'
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/sodexo/registeraddresses.vue')
      },
      //deliverynoteviewer
       {
        path: '/deliverynoteviewer',
        name: 'Deliverynoteviewer',
        meta: {
          permission: 'ADM,USER,GEOPLAN'
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/sodexo/deliverynoteviewer.vue')
      },
      //deliverynoteviewer
       {
        path: '/pack',
        name: 'Packning',
        meta: {
          permission: 'ADM,USER,GEOPLAN'
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/sodexo/pack.vue')
      },
      {
        path: '/packerslist',
        name: 'Inställningar packare',
        meta: {
          permission: 'ADM,USER,GEOPLAN'
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/sodexo/packerslist.vue')
      },
      {
        path: '/loadcarrierslist',
        name: 'Skapa lastbärare',
        meta: {
          permission: 'ADM,USER,GEOPLAN'
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/sodexo/loadcarrierlabellist.vue')
      },
      
      {
        path: '/inbox',
        name: 'Processer',
        meta: {
          permission: 'SYSADM'
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/edi/inboxlist.vue')
      },

    ]
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render(c) { return c('router-view') }
    },
    meta: {
      guest: true
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import(/* webpackChunkName: "about" */ '../views/pages/Page404.vue')
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import(/* webpackChunkName: "about" */ '../views/pages/Page500.vue')
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '../views/pages/Login.vue')
      },
    ]
  },
]

const router = new VueRouter({
  //mode: 'history',
  mode: 'hash', //Ger fula urler, men gör att det går att refresha sidan? https://stackoverflow.com/questions/36399319/vue-router-return-404-when-revisit-to-the-url
  base: process.env.BASE_URL,
  //base: '/tp/',
  routes
})
//https://www.digitalocean.com/community/tutorials/how-to-set-up-vue-js-authentication-and-route-handling-using-vue-router
router.beforeEach((to, from, next: any) => {
  //Check if logged in
  // console.log(next);
  console.log('router_beforeEach');
  if (to.matched.some(record => record.meta.guest)) {
    //alert('Guest!');
    next();
    return;
  }

  //Check if logged in, check requirements from meta-tag
  //If not OK, redirect to login page with next('pages/login')

  var isLoggedIn = usr.IsLoggedIn();

  if (!isLoggedIn) {
    next({
      path: '/pages/login',
      params: { nextUrl: to.fullPath }
    });
    return;
  }
  //Check permission
  if (usr.HasPermission(to?.meta?.permission)) {
    if (to.fullPath == '/') {
      next({
        path: '/home',
        params: { nextUrl: '/home' }
      });
      return;
    }
    console.log('Has permission:' + to?.meta?.permission);
    next();
    return;
  }


  alert('Behörighet saknas för åtgärden. Vänligen logga in igen med annat konto.');
})

export default router
